<div class="container form-section mt-3">
	<div class="d-flex justify-content-between align-items-center mb-3">
		<div class="d-flex align-items-center gap-2">
			<button class="btn-back" (click)="goBack()" ngbTooltip="Back">
				<i class="bx bx-arrow-back"></i>
			</button>
			<h3 class="mb-0 d-flex align-items-center gap-2">📋 {{ prospectData?.company_name || "Sin nombre" }}</h3>
		</div>

		<div class="d-flex gap-2">
			<button class="btn-exit" (click)="onExit()" ngbTooltip="Exit">
				<i class="bx bx-x"></i>
			</button>
		</div>
	</div>

	<p class="text-center fw-bold text-success">💰 WHEN IS THE APPOINTMENT SET FOR?</p>

	<form [formGroup]="appointmentForm">
		<div class="row g-3 mb-3">
			<div class="col-md-3">
				<label for="dateInput">Select Date</label>
				<input type="date" id="dateInput" class="form-control" formControlName="date" [min]="minDate" />
			</div>
			<div class="col-md-2">
				<label>Choose a time</label>
				<select class="form-select" formControlName="time">
					<option *ngFor="let t of times" [value]="t">{{ t }}</option>
				</select>
			</div>
			<div class="col-md-2">
				<label>Timezone</label>
				<select class="form-select" formControlName="timezone">
					<option *ngFor="let tz of usTimezones" [value]="tz.abbr">{{ tz.text2 }}</option>
				</select>
			</div>
			<div class="col-md-2">
				<label>Call Id</label>
				<div class="position-relative">
					<input class="form-control pe-5" formControlName="callId" />
					<button type="button" class="btn btn-sm btn-primary position-absolute top-50 end-0 translate-middle-y me-1" (click)="openModal(content)">GET CALLS</button>
				</div>
			</div>
			<div class="col-md-3">
				<label>Choose a campaign</label>
				<select class="form-select" formControlName="campaign_id">
					<option *ngFor="let c of activeCampaigns" [value]="c.id">
						{{ c.name }}
					</option>
					<option *ngIf="activeCampaigns.length === 0" disabled>No campaigns found</option>
				</select>
			</div>

			<!-- <label>CHOOSE A CAMPAIGN</label>
<select [(ngModel)]="appt_campaign" name="appt_campaign" class="form-control appt-select">
  <option *ngFor="let campaign of activeCampaigns" [value]="campaign.id">
    {{ campaign.name }}
  </option>
</select> -->
		</div>

		<div class="row g-3 mb-3">
			<div class="col-md-2">
				<label>Title</label>
				<div class="input-group">
					<span class="input-group-text">
						<i class="bx bxs-id-card"></i>
					</span>
					<select class="form-control" formControlName="title">
						<option *ngFor="let title of titles" [value]="title">
							{{ title }}
						</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<label>Name</label>
				<input class="form-control" formControlName="first_name" />
			</div>
			<div class="col-md-3">
				<label>Provider</label>
				<input class="form-control" formControlName="provider_1" />
			</div>
			<div class="col-md-3">
				<label>No. Employees</label>
				<input class="form-control" formControlName="employee_size" type="number" />
			</div>
		</div>

		<div class="row g-3 mb-3">
			<div class="col-md-3">
				<label>Asset Size</label>
				<input class="form-control" formControlName="plan_assets" />
			</div>
			<div class="col-md-3">
				<label>Meet Type</label>
				<select class="form-select" formControlName="meetType">
					<option value="1">Face to Face</option>
					<option value="2">Phone Call</option>
					<option value="3">Zoom Call</option>
				</select>
			</div>
			<div class="col-md-3">
				<label>Direct Line</label>
				<input class="form-control" formControlName="direct_line" />
			</div>
			<div class="col-md-3">
				<label>Extension</label>
				<input class="form-control" formControlName="extension" />
			</div>
		</div>

		<div class="row g-3 mb-3">
			<div class="col-md-2">
				<label>Renewal Month</label>
				<div class="input-group">
					<span class="input-group-text">
						<i class="bx bxs-calendar"></i>
					</span>
					<select class="form-control" formControlName="renewalMonth" placeholder="Renewal Month">
						<option value="01">January</option>
						<option value="02">February</option>
						<option value="03">March</option>
						<option value="04">April</option>
						<option value="05">May</option>
						<option value="06">June</option>
						<option value="07">July</option>
						<option value="08">August</option>
						<option value="09">September</option>
						<option value="10">October</option>
						<option value="11">November</option>
						<option value="12">December</option>
					</select>
				</div>
			</div>
			<div class="col-md-1">
				<label>Year</label>
				<select class="form-control" formControlName="renewalYear">
					<option *ngFor="let year of years" [value]="year">
						{{ year }}
					</option>
				</select>
			</div>
			<div class="col-md-4">
				<label>Email</label>
				<input class="form-control" formControlName="email" [value]="prospectData?.email" />
			</div>
		</div>

		<div class="row g-3 mb-3">
			<div class="col-md-6">
				<label>Notes</label>
				<textarea class="form-control" rows="4" formControlName="notes" [value]="prospectData?.notes"></textarea>
			</div>
			<div class="col-md-6">
				<label>Map</label>
				<iframe [src]="mapUrl" width="100%" height="160" style="border: 1px solid #ccc"> </iframe>
			</div>
		</div>
		<div class="text-center mt-4">
			<button type="submit" class="btn btn-info px-5" (click)="onSubmit()" [disabled]="isLoading">
				<ng-container *ngIf="!isLoading; else loading"> <i class="mdi mdi-cloud-upload me-2"></i> SUBMIT </ng-container>
				<ng-template #loading>
					<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
					Loading...
				</ng-template>
			</button>
		</div>
	</form>
</div>

<!-- Modal -->
<ng-template #content let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Recent Calls</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body p-3" style="max-height: 400px; overflow-y: auto">
		<div *ngFor="let call of recentCalls" class="card mb-2 p-2 call-card" [class.selected]="call === selectedCall" (click)="onSelectCall(call)" (dblclick)="selectCallId(call.id)" style="cursor: pointer">
			<div class="d-flex justify-content-between align-items-center flex-wrap">
				<div class="d-flex flex-grow-1 justify-content-between flex-wrap">
					<div class="text-start p-2">
						<div class="fw-bold">To:</div>
						<div>{{ call.to.phoneNumber }}</div>
					</div>
					<div class="text-start p-2">
						<div class="fw-bold">Duration:</div>
						<div>{{ formatDuration(call?.duration) }}</div>
					</div>
					<div class="text-start p-2">
						<div class="fw-bold">Date and Time:</div>
						<div>{{ call.startTime | date: "MMM d y, h:mm a" }}</div>
					</div>
				</div>
				<div class="text-danger fw-bold text-center ms-4 mt-2 mt-md-0 p-2">
					<div><i class="bx bx-exit"></i></div>
					<div>Outbound</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
